import type { CSSProperties } from 'react';

export const inputClass =
  'w-full rounded-lg border border-border bg-navy px-3 py-2.5 text-sm text-foreground outline-none transition placeholder:text-muted focus:border-accent focus:ring-1 focus:ring-accent/40';

export const inputReadOnlyClass =
  'w-full cursor-not-allowed rounded-lg border border-border bg-navy/60 px-3 py-2.5 text-sm text-muted outline-none';

export const labelClass = 'mb-1.5 block text-sm font-medium text-foreground';

export const cardClass =
  'rounded-2xl border border-border bg-surface/80 p-5 shadow-xl backdrop-blur sm:p-6';

/** Read-only immutable / locked field shell (CSS variables only). */
export const lockedFieldShellStyle: CSSProperties = {
  backgroundColor: 'var(--bg-secondary)',
  border: '1px solid var(--border-color)',
  borderRadius: '8px',
  padding: '10px 12px',
  color: 'var(--text-secondary)',
  cursor: 'not-allowed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  minHeight: '42px',
};

export const settingsHelperMutedStyle: CSSProperties = {
  fontSize: '12px',
  color: 'var(--text-tertiary)',
};
